import { ContributorIdentityFileModel } from './contributor.identity.file.model';

export class ContributorEditModel {
    public id: number;
    public firstName: number;
    public lastName: string;
    public email: string;
    public address: string;
    public city: string;
    public country: string;
    public currency: string;
    public zipCode: string;
    public bankName: string;
    public accountNumber: string;
    public ifsc: string;
    public uniqueNumber: string;
    public commission: number;
    public identityDocuments: Array<ContributorIdentityFileModel>;
    public documentsToRemove: Array<number>;
    public ipAddress: string;
    public state: string;
    public phone: string;
    public idNumber: string;
    public dateOfBirth: string;

    constructor() {
        this.identityDocuments = new Array<ContributorIdentityFileModel>();
        this.documentsToRemove = new Array<number>();
        this.currency = '';
    }
}
